export const job = "j11zejki";
export const outerContainer = "oq7tfm0";
export const container = "c1yv287h";
export const circle = "cdajbks";

// First variant
export const firstVariantOuterContainer = "fez9uuk";
export const firstVariantFirstCircle = "f1k9bnz3";
export const firstVariantSecondCircle = "f1hhgisb";

// Second variant
export const secondVariantOuterContainer = "s1hisqrz";
export const secondVariantFirstCircle = "s7qlclf";
export const secondVariantSecondCircle = "sinyebv";

// Third variant
export const thirdVariantOuterContainer = "t154rnzy";
export const thirdVariantFirstCircle = "t1xl991i";
export const thirdVariantSecondCircle = "tfl2b9i";

require("./styles.linaria.module.css!=!../../node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./styles.ts");